import { ClaimType } from '@yakoffice/publisher-types';
import { useRootStore } from '../../../loaders/useRootStore';

export const useEditableGameEnvironments = () => {
    const rootStore = useRootStore();
    return rootStore.gameEnvironmentsStore.gameEnvironments.filter(ge => rootStore.authStore.currentAuthUser.hasGameEnvironmentClaim(ClaimType.EditEntity, ge));
};
